import Description from './description'
import RoundBox from './round-box'

export default function DetailBlock({ provide, detail, statistics }) {
  const t = useI18n()
  return (
    <div className='flex flex-col space-y-8 max-w-[300px] text-center mx-auto md:text-sm'>
      <RoundBox>
        <Description >{ t('page:joinUs.commission.description2') }</Description>
        <div className='border-b border-gray-[#EEEEEE] w-16 mx-auto my-2'/>
        <Description>{ provide }</Description>
      </RoundBox>
      <Description className='text-left'>{ detail }</Description>
      <div className={ cn('flex items-center space-x-4 self-center', { hidden: !statistics }) }>
        <Icon.Statistic/>
        <div className='text-left'>
          { statistics?.map((staticstic, index) => <Description key={ index } whitespace='whitespace-nowrap'>{ staticstic } </Description>) }
        </div>
      </div>
    </div>
  )
}
